import {useParams} from "react-router-dom";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminProject from "../../../components/admin/project/AdminProject";

//어드민 프로젝트 페이지
const AdminProjectInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //프로젝트 식별자가 없는 경우
    if (!id) {
        return <div>Invalid project ID</div>;
    }

    return (
        <AdminLayout>
            {/*프로젝트 상세 페이지 버튼*/}
            <AdminProject projectId={parseInt(id)}/>
        </AdminLayout>
    )
}
export default AdminProjectInfoPage;